import { Component } from '@theme/component';

/**
 * `<bundle-stepbar>` — top numbered progress stepper. Highlights the current
 * step (filled) and marks earlier steps done, reflecting the builder's
 * `bundle:update`. Dots deep-link via the declarative `goToStep` binding.
 */
export class BundleStepbarComponent extends Component {
  #builder = null;

  connectedCallback() {
    super.connectedCallback();
    this.#builder = this.closest('bundle-builder');
    this.#builder?.addEventListener('bundle:update', this.#onUpdate);
    this.#builder?.requestUpdate?.();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#builder?.removeEventListener('bundle:update', this.#onUpdate);
  }

  #onUpdate = (event) => {
    const current = event.detail?.currentStep ?? 0;
    const saved = this.#builder?.state?.saved ?? [];
    for (const dot of this.querySelectorAll('.bb-stepbar__dot')) {
      const i = Number(dot.dataset.step);
      dot.setAttribute('aria-current', String(i === current));
      // Checkmark only once a product is actually selected (step saved).
      dot.toggleAttribute('data-done', Boolean(saved[i]));
    }
  };
}

if (!customElements.get('bundle-stepbar')) {
  customElements.define('bundle-stepbar', BundleStepbarComponent);
}
